import styled from "styled-components"

export const Container = styled.div`
  display: flex;
  align-items: center;
  margin: 0;
  border-radius: 0.5rem;
  padding: 1.7rem 2rem;
  bottom: 3rem;
  right: 3rem;
  font-weight: 700;
  letter-spacing: 0.05rem;
  background: ${(p) => p.theme.colors.error.background};
  border: 0.1rem solid ${(p) => p.theme.colors.borderLight};

  p {
    margin: 0;
    color: ${(p) => p.theme.colors.error.text};
  }

  p::first-letter {
    text-transform: capitalize;
  }
`
export const Title = styled.div`
  display: flex;
  flex-direction: column;

  div {
    display: flex;
    margin-bottom: 1rem;
  }

    span::first-letter {
      text-transform: capitalize;
    }


  svg {
    height: 2.2rem;
    margin-right: 1rem;
  }
`
